import { render, staticRenderFns } from "./DataRegistration.vue?vue&type=template&id=0214fcb8&scoped=true"
import script from "./DataRegistration.vue?vue&type=script&lang=js"
export * from "./DataRegistration.vue?vue&type=script&lang=js"
import style0 from "./DataRegistration.vue?vue&type=style&index=0&id=0214fcb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0214fcb8",
  null
  
)

export default component.exports